export const generalGetters = {
  generalData: (state) => state.generalData,
  territories: (state) => state.generalData && state.generalData.territories ? state.generalData.territories : [],
  currencies: (state) => state.generalData && state.generalData.currencies ? state.generalData.currencies : [],
}